import React, { useEffect, useState } from "react";
import {
  getCourseLessonCurrentLevelReports,
  saveOverviewTexts,
  getOverviewTexts,
} from "../../../lib/studentcourselessonreport";
import style from "./globalstudentcourselessonreport.module.css";
import { Toast, ToastContainer } from "react-bootstrap";
import { getColorClass ,getHeaderClass} from "./globalstudentgparigorsummary";

const levelClassMap = {
  AP: style.apCell,
  CC: style.ccCell,
  HR: style.hrCell,
  EA: style.eaCell,
  RG: style.rgCell,
  OT: style.otCell,
};

export default function GlobalStudentCourseLessonReport({
  studentId,
  isStudent = false,
}) {
  const [current, setCurrent] = useState({});
  const [departments, setDepartments] = useState([]);
  const [levels, setLevels] = useState([]);
  const [overview, setOverview] = useState({});
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const showToastMessage = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  useEffect(() => {
    loadData();
  }, [studentId]);

  const getRowTotal = (row) =>
  {
    console.log("row",row);
    levels.reduce((sum, lvl) => sum + (row[lvl] || 0), 0);
}
    const getLevelTotal = (level) =>
    departments.reduce((sum, row) => sum + (row[level] || 0), 0);

  const loadData = async () => {
    const currentRes = await getCourseLessonCurrentLevelReports(studentId);
    const overviewRes = await getOverviewTexts(studentId);

    const dataMap = {};
    const deptSet = new Set();
    const levelSet = new Set();

    currentRes.forEach((item) => {
      const { department, ...rest } = item;
      deptSet.add(department);
      dataMap[department] = {};

      Object.entries(rest).forEach(([key, value]) => {
        if (key !== "studentId") {
          dataMap[department][key] = value ?? 0;
          if (key !== "Total") levelSet.add(key); // Total ayrı gösteriliyor
        }
      });
    });

    const overviewMap = {};
    overviewRes.forEach((item) => {
      overviewMap[item.type] = item.desc;
    });

    setCurrent(dataMap);
    setDepartments([...deptSet]);
  // Custom sort order for levels
  const customOrder = ["AP", "CC", "HR", "EA", "RG", "OT"];
  const sortedLevels = customOrder.filter(lvl => levelSet.has(lvl));
  setLevels(sortedLevels);
    setOverview(overviewMap);
  };

  const handleOverviewChange = (key, value) => {
    setOverview((prev) => ({ ...prev, [key]: value }));
  };

  const handleUpdate = async () => {
    await saveOverviewTexts(studentId, overview);
    showToastMessage("Update successful!");
    loadData();
  };

console.log("departments",departments);
console.log("current",Array.isArray(current),current);


  return (
    <div className="card p-3">
      <h4 className="mb-3">Course Load</h4>
      <ToastContainer style={{ top: "1rem", right: "1rem", position: "fixed" }}>
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
      {/*}<h5 className="mb-3">Number of Courses</h5> {*/}
      <table className="table table-bordered text-center">
        <thead>
          <tr>
            <th style={{ width: "150px" }}>Department</th>
            <th>Total</th>
            {levels.map((lvl) => (
             <th key={lvl} className={getHeaderClass(lvl)}>{lvl}</th>
            ))}
            <th style={{ width: "400px" }}>Overview</th>
          </tr>
        </thead>
        <tbody>
          {departments.map((dept, index) => (
            <tr key={dept}>
              <td>{dept}</td>
              <td className={style.totalCell}>{current[dept]?.Total || 0}</td>
              {levels.map((lvl) => (
                <td
                  key={lvl}
                  className={current[dept]?.[lvl] > 0 ? getHeaderClass(lvl): ""}>
                  {current[dept]?.[lvl] ?? 0}
                </td>
              ))}
              {index === 0 && (
                <td rowSpan={departments.length} className={style.overviewCell}>
                  <div className="h-100 w-100 d-flex flex-column justify-content-between">
                    {!isStudent ? (
                      <textarea
                        rows={departments.length * 2}
                        className="form-control flex-grow-1"
                        style={{ resize: "none" }}
                        value={overview["clevelTest"] || ""}
                        onChange={(e) =>
                          handleOverviewChange("clevelTest", e.target.value)
                        }
                      />
                    ) : (
                      <div className="bg-light border rounded p-2 flex-grow-1 overflow-auto">
                        {overview["clevelTest"]}
                      </div>
                    )}
                  </div>
                </td>
              )}
            </tr>
          ))}
          {/* Total row */}
          <tr style={{ fontWeight: 'bold', background: '#f0f0f0' }}>
            <td>Total</td>
            <td className={style.totalCell}>{departments.reduce((sum, dept) => sum + (current[dept]?.Total || 0), 0)}</td>
            {levels.map((lvl) => (
              <td key={lvl} className={getHeaderClass(lvl)}>
                {departments.reduce((sum, dept) => sum + (current[dept]?.[lvl] || 0), 0)}
              </td>
            ))}
            {/* Empty cell for overview column */}
            <td></td>
          </tr>
        </tbody>
      </table>

      {!isStudent && (
        <div className="text-end">
          <button className="btn btn-primary" onClick={handleUpdate}>
            Update
          </button>
        </div>
      )}
    </div>
  );
}
